module.exports = __webpack_public_path__ + "static/img/banner_n1.798fbb19.jpg";